module.exports = __webpack_public_path__ + "static/img/solve3.df4edda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solve3.png
// module id = X2Vb
// module chunks = 0